import { ComponentStylesWithFns } from '../../../theme/styles.helpers';

export const FormSelectStyles: ComponentStylesWithFns = {
  'FormSelect-root': {
    display: 'inline-block',
  },
};
